import type { ChartGrain, ChartMetric } from "@/types/chart.types";
import { atom } from "jotai";

export const metricAtom = atom<ChartMetric>("distance");

export const grainAtom = atom<ChartGrain>("weeks");
